export default "__VITE_ASSET__1fbc621b__"